import { Component } from '@angular/core';

@Component({
  selector: 'events-card',
  templateUrl: './events-card.component.html',
  styleUrls: ['./events-card.component.scss'],
})
export class EventsCardComponent {}
